<script>
import BaseAutocompleteSearchRequestFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter';
import { PersonsService } from '@/services/persons.service';

export default {
  name: 'PersonsAutocomplete',

  extends: BaseAutocompleteSearchRequestFilter,

  props: {
    defaultSearch: {
      type: String,
      default: null
    }
  },

  watch: {
    defaultSearch: {
      deep: true,
      immediate: true,
      handler() {
        this.setSearch();
      }
    }
  },

  methods: {
    setSearch() {
      if (this.defaultSearch) {
        this.search = this.defaultSearch;
      }
    },
    getData(search) {
      return PersonsService.getFilteredPersons({ search }).then(({ data }) => {
        return data.data;
      });
    }
  }
};
</script>
